import secureApi from '../../utils/secureApi';
import { Banner } from '../../pages/BannerManagement/types';

interface GetAllBannersParams {
  bannerLocation: string;
  page: number;
  pageSize: number;
  search?: string;
  platform?: string;
}

interface GetAllBannersResponse {
  page: number;
  paginatedResults: Banner[];
  totalCount: number;
  totalPages: number;
}

export async function getAllBanners(params: GetAllBannersParams) {
  const response = await secureApi.get<any>(
    `/api/v1/tournaments/admin/banners/get-all-banners`,
    {
      params: {
        bannerLocation: params.bannerLocation,
        page: params.page,
        pageSize: params.pageSize,
        ...(params.search ? { search: params.search } : {}),
        ...(params.platform ? { platform: params.platform } : {}),
      }
    }
  );

  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  const apiData = (response as any)?.data || response;
  return {
    ...apiData,
    paginatedResults: (apiData.paginatedResults || []).map((banner: any) => ({
      ...banner,
      id: banner._id,
    })),
  };
} 